export enum TARGET_MARKET {
  NEW_ZEALAND = 'NewZealand',
  AUSTRALIA = 'Australia',
}

export const TARGET_MARKET_OPTIONS = [
  { id: TARGET_MARKET.NEW_ZEALAND, name: 'New Zealand' },
  { id: TARGET_MARKET.AUSTRALIA, name: 'Australia' },
];

export enum AUTH_PROCESSING_STATUS {
  PENDING = 'Pending',
  IN_PROGRESS = 'InProgress',
  SUCCESS = 'Success',
  FAILED = 'Failed',
}
